module.exports = __webpack_public_path__ + "static/media/bizpage-preview.81f93fe3.png";